const api = "https://py.precious-lab.com/live/graphql/";
const diamondListingApi = "diamondData";
const diamondDetailApi = "diamondById";
const diamondSearchByReportApi = "devDiamondByStockorcert";
const diamondAddToCart = "diamondAddToCart";
const productMetafield = "productMetafield";
const ringAddToCart = "ringAddToCart";


var currencyCode = 'JPY';
var currencyInfo = localStorage.getItem("cvc_switcher");
if(currencyInfo != '' && currencyInfo != null && currencyInfo != undefined){
  currencyInfo = JSON.parse(currencyInfo);
  currencyCode = currencyInfo.value.currency;
}
var currencySymbol = getCurrenySymbol(currencyCode);

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** Refine Your Results Focus To Filter Section ***/
// function refineYourResults(){
//   var target = '#tps-diamond-filters-text-icon'; 
//   $('html, body').animate({
//         scrollTop: $(target).offset().top - 250
//   }, 'slow'); 
// }
function refineYourResults() {
  var target;

  // Check if mobile view (screen width < 768px for example)
  if ($(window).width() <= 768) {
    target = '.tps_mob_filter_section';
  } else {
    target = '#tps-diamond-filters-text-icon';
  }

  // Scroll to the selected target
  if ($(target).length) {
    $('html, body').animate({
      scrollTop: $(target).offset().top - 250
    }, 'slow');
  }
}
/*** End ***/

// Add near top of the <script> in diamond_filters.liquid
var flourFilterUnit = (store_lang == 'ja') ? '蛍光性' : 'Fluorescence';
var colorFilterUnit = (store_lang == 'ja') ? 'カラー' : 'Color';
var mediaFilterUnit = (store_lang == 'ja') ? 'メディア' : 'Media';

/*** Mobile Step Icon Click Info Popup Start ***/
// $(document).on("click", ".tps-step-icon", function(){
//   // if(jQuery(window).width() <= 991){    
//     var data_step = jQuery(this).attr("data-step");
//     var setting_info = localStorage.getItem("ring_setting");
//     var ring_diamond = localStorage.getItem("ring_diamond");
//     var ring_step1 = localStorage.getItem("ring_step1");
//     var ring_step2 = localStorage.getItem("ring_step2");

//     jQuery('.tps-steps-details').removeClass('tps-step-product-info-show');
//     jQuery('.tps-'+data_step+'-step-product-info').addClass('tps-step-product-info-show');

//   // } 
// });
$(document).on("click", ".tps-step-icon", function () {
  const data_step = $(this).attr("data-step"); // 'first', 'second', or 'final'

  // Get step blocks (make sure these selectors match your HTML)
  const step1 = $(".step.step1");
  const step2 = $(".step.step2");

  // Parse localStorage safely
  const setting_info = JSON.parse(localStorage.getItem("ring_setting") || "[]");
  const diamond_info = JSON.parse(localStorage.getItem("ring_diamond") || "[]");

  let redirectURL = "";

  // console.log("Clicked step:", data_step);
  // console.log("step1 classes:", step1.attr("class"));
  // console.log("step2 classes:", step2.attr("class"));

  // Show correct product info section
  $(".tps-steps-details").removeClass("tps-step-product-info-show");
  $(".tps-" + data_step + "-step-product-info").addClass("tps-step-product-info-show");

});


/*** Mobile Step Icon Click Info Popup End ***/

/*** Product Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-steps-details");
  var container2 = $(".tps-step-icon");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0){     
    jQuery(".tps-steps-details").removeClass('tps-step-product-info-show');
  }
});
/*** Product Info Popoup Close Outer Click End ***/


/*** Pre Declare Filter Arrays ***/
// const shape_array = {"Round": "ラウンド", "Princess": "プリンセス", "Emerald": "エメラルド", "Asscher": "アッシャー", "Marquise": "マーキス", "Oval": "オーバル", "Baguette": "バゲット", "Pear": "ペア", "Heart": "ハート", "Cushion": "クッション", "Radiant": "ラディアント"};
// const ja_shape_array = {"ラウンド": "Round", "プリンセス": "Princess", "エメラルド": "Emerald", "アッシャー": "Asscher", "マーキス": "Marquise", "オーバル": "Oval", "バゲット": "Baguette", "ペア": "Pear", "ハート": "Heart", "クッション": "Cushion", "ラディアント": "Radiant"};
// const ja_metal_array = {"18kホワイトゴールド": "white gold", "18kイエローゴールド": "yellow gold", "18kローズゴールド": "rose gold", "白金": "white gold","platinum 950":"白金"};
const color_array = {"D": "D","E": "E","F": "F","G": "G","H": "H","I": "I","J": "J"};
const clarity_array = {"FL": "FL","IF": "IF","VVS1": "VVS1","VVS2": "VVS2","VS1": "VS1","VS2": "VS2","SI1": "SI1","SI2": "SI2"};
//const cut_array = {"Ideal": "理想的", "Excellent": "素晴らしい","Very Good": "非常に良い"};

const shape_array = {
  "Round": "ラウンド",
  "Princess": "プリンセス",
  "Emerald": "エメラルド",
  "Asscher": "アッシャー",
  "Marquise": "マーキス",
  "Oval": "オーバル",
  "Baguette": "バゲット",
  "Pear": "ペアシェイプ",
  "Heart": "ハート",
  "Cushion": "クッション",
  "Radiant": "ラディアント"
};

var ja_shape_array = {
  "ラウンド": "Round",
  "プリンセス": "Princess",
  "エメラルド": "Emerald",
  "アッシャー": "Asscher",
  "マーキス": "Marquise",
  "オーバル": "Oval",
  "バゲット": "Baguette",
  "ペアシェイプ": "Pear",
  "ハート": "Heart",
  "クッション": "Cushion",
  "ラディアント": "Radiant"
};

const ja_metal_array = {
  "K18ホワイトゴールド": "white gold",
  "K18イエローゴールド": "yellow gold",
  "K18ローズゴールド": "rose gold",
  "プラチナ": "platinum",
  "Pt950": "platinum 950"
};

const cut_array = {
  "Ideal": "アイデアル",
  "8x": "8X",
  "Excellent": "エクセレント",
  "Very Good": "ベリーグッド",
  "Good": "グッド"
};

const ja_cut_array = {
  "アイデアル": "Ideal",
  "8X": "8x",
  "エクセレント": "Excellent",
  "ベリーグッド": "Very Good",
  "グッド": "Good",
  "NA": "NA"
};

const fluorescence_array = {
  "None": "なし",
  "Faint": "フェイント",
  "Medium": "ミディアム",
  "Strong": "ストロング",
  "Very Strong": "ベリーストロング"
};

const ja_fluor = {
  "なし": "None",
  "フェイント": "Faint",
  "ミディアム": "Medium",
  "ストロング": "Strong",
  "ベリーストロング": "Very Strong"
};

const polish_array = {
  "Good": "グッド",
  "Very Good": "ベリーグッド",
  "Excellent": "エクセレント"
};

const ja_polish_array = {
  "グッド": "Good",
  "ベリーグッド": "Very Good",
  "エクセレント": "Excellent"
};

const symmetry_array = {
  "Good": "グッド",
  "Very Good": "ベリーグッド",
  "Excellent": "エクセレント"
};

const ja_symmetry_array = {
  "グッド": "Good",
  "ベリーグッド": "Very Good",
  "エクセレント": "Excellent"
};

const intensity_array = {
  "Fancy Light": "ファンシーライト",
  "Fancy": "ファンシー",
  "Fancy Dark": "ファンシーダーク",
  "Fancy Intense": "ファンシーインテンス",
  "Fancy Deep": "ファンシーディープ",
  "Fancy Vivid": "ファンシービビッド"
};

const ja_intensity_array = {
  "ファンシーライト": "Fancy Light",
  "ファンシー": "Fancy",
  "ファンシーダーク": "Fancy Dark",
  "ファンシーインテンス": "Fancy Intense",
  "ファンシーディープ": "Fancy Deep",
  "ファンシービビッド": "Fancy Vivid"
};

const fancyColor_array = {
  "Yellow": "イエロー",
  "Blue": "ブルー",
  "Pink": "ピンク",
  "Brown": "ブラウン",
  "Green": "グリーン",
  "Red": "レッド",
  "Gray": "グレー",
  "Black": "ブラック",
  "Orange": "オレンジ"
};

const ja_fancyColor_array = {
  "イエロー": "Yellow",
  "ブルー": "Blue",
  "ピンク": "Pink",
  "ブラウン": "Brown",
  "グリーン": "Green",
  "レッド": "Red",
  "グレー": "Gray",
  "ブラック": "Black",
  "オレンジ": "Orange"
};






/*** End ***/

/*** get currency symbol start ***/
function getCurrenySymbol(CurrenyCode) {
	var currency_symbol;
	switch (CurrenyCode) {
		// for now we have only single currency*- USD
      case 'JPY':
			currency_symbol = '¥';
			break;
        case 'AUD':
			currency_symbol = '$';
			break;
        case 'CAD':
			currency_symbol = '$';
			break;
        case 'GBP':
			currency_symbol = '\xA3';
			break;
        case 'HKD':
			currency_symbol = '$';
			break;
        case 'NZD':
			currency_symbol = 'NZ$';
			break;
        case 'USD':
			currency_symbol = '$';
			break;
        case 'SGD':
			currency_symbol = '$';
			break;
        case 'EUR':
			currency_symbol = '\u20AC';
			break;
        case 'CHF':
			currency_symbol = '₣';
			break;

		default:
			currency_symbol = '¥';
	}

	return currency_symbol;
}
/*** get currency symbol end ***/

/*** addCommas in price start ***/
function addCommas(price) {
  price += '';
  x = price.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}
/*** addCommas in price end ***/

/*** set selected filters for session filters after reloading page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {
  // console.log(filter_value, input_value, func, hasSelectedClass);
  // console.log("input_value",input_value);
  // remove specific input containers if present (existing behavior)
  if (input_value == 'price') {
    $('.selected_filter_container').find('li[data-input="price"]').remove();
  } else if (input_value == 'carat') {
    $('.selected_filter_container').find('li[data-input="carat"]').remove();
  } else if (input_value == 'depth') {
    $('.selected_filter_container').find('li[data-input="depth"]').remove();
  } else if (input_value == 'ratio') {
    $('.selected_filter_container').find('li[data-input="ratio"]').remove();
  } else if (input_value == 'table') {
    $('.selected_filter_container').find('li[data-input="table"]').remove();
  } else if (input_value == 'color') {
    $('.selected_filter_container').find('li[data-input="color"]').remove();
  } else if (input_value == 'clarity') {
    $('.selected_filter_container').find('li[data-input="clarity"]').remove();
  } else if (input_value == 'cut') {
    $('.selected_filter_container').find('li[data-input="cut"]').remove();
  } else if (input_value == 'polish') {
    $('.selected_filter_container').find('li[data-input="polish"]').remove();
  } else if (input_value == 'intensity') {
    $('.selected_filter_container').find('li[data-input="intensity"]').remove();
  }else if (input_value == 'symmetry') {
    $('.selected_filter_container').find('li[data-input="symmetry"]').remove();
  }

  var value = filter_value.split(':');

  if (hasSelectedClass) {
    var html = '';
    var filter_lable = value[1] ? value[1].trim() : '';

    // keep replacing hyphens for most inputs as before
    if(input_value != 'price' && input_value != 'carat' && input_value != 'depth' && input_value != 'ratio' && input_value != 'table' && input_value != 'cut' && input_value != 'polish' && input_value != 'symmetry' && input_value != 'fluorescence' && input_value != 'clarity' && input_value != 'color' && input_value != 'intensity') {
           filter_lable = filter_lable.replace(/\-/g, ' ');
         }

    // build the list item showing the value (we always show the value)
    html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps_filter_values">' + filter_lable + '<span class="tps-pendantbuilder-remove-option"></span></div></li>';

    // container id based on the prefix (value[0])
    var containerId = value[0] + '_container';

    if ($('#' + value[0] + '_container').length > 0) {
			$('#' + value[0] + '_container').append(html);
		} else {
      // create container
      // If input is CVD, do NOT add the label heading; only create an empty UL container
      if (String(input_value).toLowerCase() === 'cvd') {
        var elecontainer = '<ul id="' + value[0] + '_container"></ul>';
      } else {
        var elecontainer = '<ul id="' + value[0] + '_container"><span class="tps_applied_filter_lable">' + value[0] + ':</span></ul>';
      }

      $('.selected_filter_container').append(elecontainer);
      $('#' + containerId).append(html);
    }
  } else {
    $('.selected_filter_container').find('li[data-filter_value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '_container li').length == 0) {
			$('#' + value[0] + '_container').remove();
		}
	}
	if ($('.selected_filter_container li').length > 0) {
		$('.tps_selected_filter_wrapper').show();
	} else {
		$('.tps_selected_filter_wrapper').hide();
	}
}
/*** set selected filters for session filters after reloading page end ***/

/*** tps config function to get urls start ***/
if(store_lang == 'ja'){
  var tps_config = {
	"urls": {        
        "ring_builder_listing": "/ja/collections/build-your-own-ring",		
        "ringbuilder_lab_diamond": "/ja/pages/ring-builder-lab-diamond-listing",
        "ringbuilder_fancy_lab_diamond": "/ja/pages/ringbuilder-lab-color-diamonds",
		    "ringbuilder_loose_diamond_detail": "/ja/pages/ring-builder-diamond-details",
        "ring_builder_final_page": "/ja/pages/final-ring",
        // "loose_diamond": "/ja/pages/loose-diamond",
        "lab_diamond": "/ja/pages/lab-diamond",
        "lab_fancy_diamond": "/ja/pages/lab-color-diamonds",
        "loose_diamond_detail": "/ja/pages/diamond-details",
	}
  }
}else{
  var tps_config = {
	"urls": {        
        "ring_builder_listing": "/collections/build-your-own-ring",		
		// "ringbuilder_loose_diamond": "/pages/ring-builder-diamond-listing",
        "ringbuilder_lab_diamond": "/pages/ring-builder-lab-diamond-listing",
        "ringbuilder_fancy_lab_diamond": "/pages/ringbuilder-lab-color-diamonds",
		    "ringbuilder_loose_diamond_detail": "/pages/ring-builder-diamond-details",
        "ring_builder_final_page": "/pages/final-ring",
        // "loose_diamond": "/pages/loose-diamond",
        "lab_diamond": "/pages/lab-diamond",
        "lab_fancy_diamond": "/pages/lab-color-diamonds",
        "loose_diamond_detail": "/pages/diamond-details",
	}
  }
}

/*** tps config function to get urls end ***/

/*** Diamond Carat Filter Start ***/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
//alert(minDiamondCarat);
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());
var carat = [];
/* Carat Calibreation Start*/ 
for (i = minDiamondCarat; i < 1; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 2; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 2; i < maxDiamondCarat; i = i + 0.10) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
// for (i = 3; i < maxDiamondCarat; i = i + 0.15) {
// 	var dec = i.toFixed(2);
// 	carat.push(dec);
// }
/* Carat Calibreation End*/ 
carat.push(maxDiamondCarat);

Shopify.money_format = '¥{{amount_no_decimals }}';
var currency_symbol = "¥";


function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}

if(store_lang == 'ja'){
  var caratFilterUnit = 'カラット';
}else{
  var caratFilterUnit = 'Carat';
}                       

function carat_slider_render(start, end, option, forceApplied) { 
    var start2 = getClosestNum(start, carat);
    var end2 = getClosestNum(end, carat);   
    var start1 = get_index(start2, carat);
    var start11 = get_index(start, carat);
    var end11 = get_index(end, carat);
    var end1 = get_index(end2, carat);
  
    var settingSelected = jQuery("#setting").val();
    var pendant_setting = localStorage.getItem("pendant_setting");
    var ring_setting = localStorage.getItem("ring_setting");

    // Get the original default min/max values (before any setting modifications)
    var original_min_carat = parseFloat("{{diamondMincarat}}").toFixed(2);
    var original_max_carat = parseFloat("{{diamondMaxcarat}}").toFixed(2);
    
    // Get the current allowed min/max values (which might be modified by ring settings)
    var allowed_min_carat = parseFloat($("#diamondMincarat").val()).toFixed(2);
    var allowed_max_carat = parseFloat($("#diamondMaxcarat").val()).toFixed(2);

    if (window.location.href.indexOf('ring-builder-lab-diamond-listing') > 0) {
       if(localStorage.getItem("ring_setting") != null){
          var ringsetting_details = jQuery.parseJSON(ring_setting);
          if (ringsetting_details[0].minimum_carat_total_weight) {
            allowed_min_carat = parseFloat(ringsetting_details[0].minimum_carat_total_weight).toFixed(2);
          }
          if (ringsetting_details[0].maximum_carat_total_weight) {
            allowed_max_carat = parseFloat(ringsetting_details[0].maximum_carat_total_weight).toFixed(2);
          }
       }
    }
  
    // Check if current values differ from allowed range OR if force applied
    var isSelected = false;
    var currentMin = parseFloat(start).toFixed(2);
    var currentMax = parseFloat(end).toFixed(2);
    
    // For ring-builder page, use forceApplied flag if provided, otherwise compare with allowed range
    if (window.location.href.indexOf('ring-builder-lab-diamond-listing') > 0 && forceApplied !== undefined) {
        isSelected = forceApplied;
    } else {
        // Compare against current allowed range for other pages
        if (currentMin != allowed_min_carat || currentMax != allowed_max_carat) {
            isSelected = true;
        }
    }
       
    var caratTitle = caratFilterUnit + ': ' + currentMin + ' ct. - ' + currentMax + ' ct.';
    
    // For reset function, use the allowed range (which respects ring settings)
    setSelectedFilter(caratTitle, "carat_slider_render('" + allowed_min_carat + "', '" + allowed_max_carat + "','true')", isSelected, 'carat');

    // Rest of your existing slider code...
    var allowed_min = parseFloat($("#diamondMincarat").val());
    var allowed_max = parseFloat($("#diamondMaxcarat").val());
    
    if (window.location.href.indexOf('ring-builder-lab-diamond-listing') > 0 && localStorage.getItem("ring_setting") != null) {
        var ringsetting_details = jQuery.parseJSON(localStorage.getItem("ring_setting"));
        if (ringsetting_details[0].minimum_carat_total_weight)
            allowed_min = parseFloat(ringsetting_details[0].minimum_carat_total_weight);
        if (ringsetting_details[0].maximum_carat_total_weight)
            allowed_max = parseFloat(ringsetting_details[0].maximum_carat_total_weight);
    }

    jQuery("#carat-slider").slider({
        range: true,
        min: 0,
        max: carat.length - 1,
        values: [start1, end1],
        slide: function(event, ui) {
            emptyResultDiv();
            var newMin = parseFloat(carat[ui.values[0]]);
            var newMax = parseFloat(carat[ui.values[1]]);
            if (ui.values[0] > ui.values[1]) {
                return false;
            }
            if (settingSelected == 1 && (newMin < allowed_min || newMax > allowed_max)) {
                return false;
            }
            $("#carat_from").val(newMin.toFixed(2) + ' ct.');
            $('#carat_left_hidden').val(newMin);
            $('#carat_to').val(newMax.toFixed(2) + ' ct.');
            $('#carat_right_hidden').val(newMax);
        },
        change: function(event, ui) {
            emptyResultDiv();
            var newMin = parseFloat(carat[ui.values[0]]);
            var newMax = parseFloat(carat[ui.values[1]]);
            if (ui.values[0] > ui.values[1]) {
                return false;
            }
            if (settingSelected == 1 && (newMin < allowed_min || newMax > allowed_max)) {
                return false;
            }
            if (option) {
                jQuery('#page_no').val(1);
                jQuery('#pagination').val('');
                
                // For ring-builder page, always show as applied when values differ from original defaults
                var isSelected = false;
                if (window.location.href.indexOf('ring-builder-lab-diamond-listing') > 0) {
                    if (newMin.toFixed(2) != original_min_carat || newMax.toFixed(2) != original_max_carat) {
                        isSelected = true;
                    }
                } else {
                    // For other pages, compare against allowed range
                    if (newMin.toFixed(2) != allowed_min_carat || newMax.toFixed(2) != allowed_max_carat) {
                        isSelected = true;
                    }
                }
                
                setTimeout(function() {
                    var caratTitle = caratFilterUnit + ': ' + newMin.toFixed(2) + ' ct. - ' + newMax.toFixed(2) + ' ct.';
                    // For reset, use allowed range
                    setSelectedFilter(caratTitle, "carat_slider_render('" + allowed_min_carat + "', '" + allowed_max_carat + "','true')", isSelected, 'carat');
                    graphqlDataCall();
                }, 20);
            }
        }
    });
    
    start = start ? start : allowed_min_carat; // Use allowed range instead of minDiamondCarat
    $("#carat_from").val(parseFloat(start).toFixed(2) + ' ct.');
    $("#carat_to").val(parseFloat(end).toFixed(2) + ' ct.');
    $('#carat_left_hidden').val(start);
    $('#carat_right_hidden').val(end);
}

function replace_carat_from() {
    // Get the default min carat value from localStorage
    var default_min_carat = parseFloat(localStorage.getItem('default_min_carat'));
    var min_carat_value = parseFloat($('#diamondMincarat').val());
    var max_carat_value = parseFloat($('#carat_right_hidden').val());
    var settingSelected = jQuery("#setting").val();

    // Clean and parse input
    var input = jQuery('#carat_from').val().replace(/[^\d.]/g, '');
    var value = parseFloat(input);

    // If empty, restore previous value
    if (!input) {
        var prev = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2);
        jQuery('#carat_from').val(prev + ' ct.');
        return false;
    }

    // If not a number, reset to min
    if (isNaN(value)) {
        value = min_carat_value;
        if (store_lang == 'ja') {
            alert("数値を入力してください。");
        } else {
            alert("Please enter value in number");
        }
        jQuery('#carat_from').val(value.toFixed(2) + ' ct.');
        jQuery('#carat_left_hidden').val(value.toFixed(2));
        carat_slider_render(value, max_carat_value, true);
        return false;
    }

    // Clamp value to allowed range
    if (value < min_carat_value) {
        value = min_carat_value;
        if (store_lang == 'ja') {
            alert('最小値より小さいです。');
        } else {
            alert('Value cannot be less than ' + min_carat_value + ' ct.');
        }
        jQuery('#carat_from').val(value.toFixed(2) + ' ct.');
        jQuery('#carat_left_hidden').val(value.toFixed(2));
        carat_slider_render(value, max_carat_value, true);
        return false;
    }
    if (value > max_carat_value) {
        value = max_carat_value;
        if (store_lang == 'ja') {
            alert('最大値を超えています。');
        } else {
            alert('Min carat must be less than max carat');
        }
        jQuery('#carat_from').val(value.toFixed(2) + ' ct.');
        jQuery('#carat_left_hidden').val(value.toFixed(2));
        carat_slider_render(value, max_carat_value, true);
        return false;
    }

    // Setting logic: compare to default min carat, not just hidden value
    if (settingSelected == 1) {
        if (value < default_min_carat) {
            if (store_lang == 'ja') {
                alert('選択されたセッティングは、' + default_min_carat + 'ct. 以上のダイヤモンドにマッチします。');
            } else {
                alert('Selected setting cannot match with diamond less than ' + default_min_carat + ' ct.');
            }
            jQuery('#carat_from').val(default_min_carat.toFixed(2) + " ct.");
            jQuery('#carat_left_hidden').val(default_min_carat.toFixed(2));
            carat_slider_render(default_min_carat, max_carat_value, true);
            return false;
        }
    }

    // All checks passed, update hidden and visible fields
    jQuery('#carat_from').val(value.toFixed(2) + ' ct.');
    jQuery('#carat_left_hidden').val(value.toFixed(2));
    jQuery('#carat_right_hidden').val(max_carat_value);

    carat_slider_render(value, max_carat_value, true);
}

function replace_carat_to() {
    // Get the default max carat value from localStorage
    var default_max_carat = parseFloat(localStorage.getItem('default_max_carat'));
    var max_carat_value = parseFloat($('#diamondMaxcarat').val());
    var min_carat_value = parseFloat($('#carat_left_hidden').val());
    var settingSelected = jQuery("#setting").val();

    // Clean and parse input
    var input = jQuery('#carat_to').val().replace(/[^\d.]/g, '');
    var value = parseFloat(input);

    // If empty, restore previous value
    if (!input) {
        var prev = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
        jQuery('#carat_to').val(prev + ' ct.');
        return false;
    }

    // If not a number, reset to max
    if (isNaN(value)) {
        value = max_carat_value;
        if (store_lang == 'ja') {
            alert("数値を入力してください。");
        } else {
            alert("Please enter value in number");
        }
        jQuery('#carat_to').val(value.toFixed(2) + ' ct.');
        jQuery('#carat_right_hidden').val(value.toFixed(2));
        carat_slider_render(min_carat_value, value, true);
        return false;
    }

    // Clamp value to allowed range
    if (value > max_carat_value) {
        value = max_carat_value;
        if (store_lang == 'ja') {
            alert('最大値を超えています。');
        } else {
            alert('Value cannot exceed ' + max_carat_value + ' ct.');
        }
        jQuery('#carat_to').val(value.toFixed(2) + ' ct.');
        jQuery('#carat_right_hidden').val(value.toFixed(2));
        carat_slider_render(min_carat_value, value, true);
        return false;
    }
    if (value < min_carat_value) {
        value = min_carat_value;
        if (store_lang == 'ja') {
            alert('最小値より小さいです。');
        } else {
            alert('Max carat must be greater than min carat');
        }
        jQuery('#carat_to').val(value.toFixed(2) + ' ct.');
        jQuery('#carat_right_hidden').val(value.toFixed(2));
        carat_slider_render(min_carat_value, value, true);
        return false;
    }

    // Setting logic: compare to default max carat, not just hidden value
    if (settingSelected == 1) {
        if (value > default_max_carat) {
            if (store_lang == 'ja') {
                alert('選択されたセッティングは、' + default_max_carat + 'ct. 以下のダイヤモンドにマッチします。');
            } else {
                alert('Selected setting cannot match with diamond greater than ' + default_max_carat + ' ct.');
            }
            jQuery('#carat_to').val(default_max_carat.toFixed(2) + " ct.");
            jQuery('#carat_right_hidden').val(default_max_carat.toFixed(2));
            carat_slider_render(min_carat_value, default_max_carat, true);
            return false;
        }
    }

    // All checks passed, update hidden and visible fields
    jQuery('#carat_to').val(value.toFixed(2) + ' ct.');
    jQuery('#carat_right_hidden').val(value.toFixed(2));
    jQuery('#carat_left_hidden').val(min_carat_value);

    carat_slider_render(min_carat_value, value, true);
}

/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
var price = [];
var minDiamondPrice = $('#diamondMinprice').val();
var maxDiamondPrice = $('#diamondMaxprice').val();

for (var i = 20000; i < 30000; i = i+1) {
  price.push(i);
};
for (var i = 30000; i < 40000; i = i+3) {
  price.push(i);
};
for (var i = 40000; i < 50000; i = i+7) {
  price.push(i);
};
for (var i = 50000; i < 100000; i = i+10) {
  price.push(i);
};
for (var i = 100000; i < 500000; i = i+13) {
  price.push(i);
};
for (var i = 500000; i < 100000; i = i+15) {
  price.push(i);
};
for (var i = 100000; i < 500000; i = i+20) {
  price.push(i);
};
for (var i = 500000; i < 1000000; i = i+25) {
  price.push(i);
};


price.push(parseInt(maxDiamondPrice));

// function addCommas(price) {
// 	price += '';
// 	x = price.split('.');
// 	x1 = x[0];
// 	x2 = x.length > 1 ? '.' + x[1] : '';
// 	var rgx = /(\d+)(\d{3})/;
// 	while (rgx.test(x1)) {
// 		x1 = x1.replace(rgx, '$1' + ',' + '$2');
// 	}
// 	return x1 + x2;
// }
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

var diamondMinprice = $('#diamondMinprice').val();
var diamondMaxprice = $('#diamondMaxprice').val();

if(store_lang == 'ja'){
  var priceFilterUnit = '価格';
}else{
  var priceFilterUnit = 'Price';
}  

let cleanPriceTimer;

// Function to clean price fields with a delay
function delayedCleanPrice() {
    clearTimeout(cleanPriceTimer);
    cleanPriceTimer = setTimeout(() => {
        jQuery('#price_to, #price_from').each(function () {
            let value = jQuery(this).val();
            let cleanedValue = $("<span>").html(value).text().trim();
            if (value !== cleanedValue) {
                jQuery(this).val(cleanedValue);
            }
        });
    }, 2000); 
}

function price_slider_render(start, end, option) {

    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);  
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2); 

     //session price filter selected
     var isSelected = false;
     if(start != diamondMinprice || end != diamondMaxprice){
       isSelected = true;
     }

    var priceTitle = priceFilterUnit+': '+Shopify.formatMoney(start*100, theme.moneyFormat)+' - '+Shopify.formatMoney(end*100, theme.moneyFormat);
     //var priceTitle = 'Price: '+currencySymbol+addCommas(start)+' - '+currencySymbol+addCommas(end);

 
     setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
     //end
  
   jQuery('#price-slider').slider({
       range: true,
       // values: [start, end],
       // min: Number(diamondMinprice),
       // max: Number(diamondMaxprice),
       // step: 1,
         min: 0,
         max: price.length-1,
         values: [ start1,end1 ],
         step:0.1,
       slide: function (event, ui) {         
       // emptyResultDiv();
         
         if ((ui.values[0]) > (ui.values[1])) { 
            return false; 
        }
          jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
          jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
         
          // var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
          var price_form = currencySymbol+addCommas(price[parseInt(ui.values[0])].toFixed(0));
          jQuery('#price_from').val(price_form);
          //var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
          var price_to = currencySymbol+addCommas(price[parseInt(ui.values[1])].toFixed(0));
          jQuery('#price_to').val(price_to);

         option = true;

         // delayedCleanPrice(); 
       }, change: function (event, ui) {
         if(option == true) {
           emptyResultDiv();
           
           jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
           jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);


          // setTimeout(function(){   
           //var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
           var price_form = currencySymbol+addCommas(price[parseInt(ui.values[0])].toFixed(0));
           jQuery('#price_from').val(price_form);
           // var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
           var price_to = currencySymbol+addCommas(price[parseInt(ui.values[1])].toFixed(0));           
           jQuery('#price_to').val(price_to);
           
          //applied filters 
           var isSelected = false;
           if(price[parseInt(ui.values[0])] != diamondMinprice || price[parseInt(ui.values[1])] != diamondMaxprice){
              isSelected = true;
           } 
           
           var priceTitle = priceFilterUnit+': '+price_form+' - '+price_to;
           setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
          //end

          jQuery('#page_no').val(1);
    	  jQuery('#pagination').val('');
           
           // var reportFlag = jQuery('#tps_search_by_report_no').val();                
           // if(reportFlag == ''){
             graphqlDataCall();

            // delayedCleanPrice(); 
          // }, 20);
            
           // }           
         }else if(option == false){      
             // option = true;

           // setTimeout(function(){  
             jQuery('#price_left_hidden').val(start);
             jQuery('#price_right_hidden').val(end);

             // var price_form = ""+Shopify.formatMoney(start*100, theme.moneyFormat);
             var price_form = currencySymbol+addCommas(start);
             jQuery('#price_from').val(price_form);
             // var price_to = ""+Shopify.formatMoney(end*100, theme.moneyFormat);
             var price_to = currencySymbol+addCommas(end);
             jQuery('#price_to').val(price_to);

             jQuery('#page_no').val(1);
             jQuery('#pagination').val('');
          
             graphqlDataCall();  

             // delayedCleanPrice();              
           // }, 20);
             setTimeout(function(){
               option = true;
             }, 25); 

           return false;
         }
         
       }
     });

    var start_num = parseInt(start);
	var end_num = parseInt(end);

	var start_dec = start_num.toFixed(0);
	var end_dec = end_num.toFixed(0);

	jQuery('#price_left_hidden').val(start_dec);
	jQuery('#price_right_hidden').val(end_dec);
    jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
  	jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));

  // setTimeout(function(){ 
  delayedCleanPrice(); 
  // }, 2000);
}

function get_priceindex(value) {
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_to() {
    let raw = jQuery('#price_to').val();
    let hiddenRight = jQuery('#price_right_hidden').val();
    let hiddenLeft = jQuery('#price_left_hidden').val();

    // If input is empty, re-apply last changed (hidden) values
    if (raw === '' || raw == null) {
        let value = parseInt(hiddenRight, 10) || parseInt($('#diamondMaxprice').val(), 10);
        let value1 = parseInt(hiddenLeft, 10) || parseInt($('#diamondMinprice').val(), 10);

        // update visible input and slider using last known values
        jQuery('#price_to').val(currencySymbol + addCommas(value));
        jQuery('#price_from').val(currencySymbol + addCommas(value1));
        jQuery('#price_right_hidden').val(value.toFixed(0));
        jQuery('#price_left_hidden').val(value1.toFixed(0));
        price_slider_render(value1, value, false);
        return true;
    }

    let value = raw.replace(currencySymbol, '').replace(/,/g, '').replace(/[^\d\.]/g, '');
    let value1 = jQuery('#price_left_hidden').val().replace(currencySymbol, '').replace(/,/g, '').replace(/[^\d\.]/g, '');

    value = parseInt(value, 10);
    value1 = parseInt(value1, 10);

    if (isNaN(value)) {
        alert(store_lang == 'ja' ? "数値を入力してください。" : "Please enter value in number");
        jQuery('#price_to').val(currencySymbol + addCommas($('#diamondMaxprice').val()));
        return false;
    }
    if (value > parseInt($('#diamondMaxprice').val(), 10)) {
        alert(store_lang == 'ja' ? '価格帯が正しくない！' : 'Incorrect price range!');
        jQuery('#price_to').val(currencySymbol + addCommas($('#diamondMaxprice').val()));
        return false;
    }
    if (value1 > value) {
        alert(store_lang == 'ja' ? '価格帯が正しくない！' : 'Incorrect price range!');
        jQuery('#price_to').val(currencySymbol + addCommas($('#diamondMaxprice').val()));
        return false;
    }

    jQuery('#price_right_hidden').val(value.toFixed(0));
    jQuery('#price_left_hidden').val(value1.toFixed(0));
    price_slider_render(value1, value, false);
}

function replace_price_from() {
    let raw = jQuery('#price_from').val();
    let hiddenLeft = jQuery('#price_left_hidden').val();
    let hiddenRight = jQuery('#price_right_hidden').val();

    // If input is empty, re-apply last changed (hidden) values
    if (raw === '' || raw == null) {
        let value = parseInt(hiddenLeft, 10) || parseInt($('#diamondMinprice').val(), 10);
        let value1 = parseInt(hiddenRight, 10) || parseInt($('#diamondMaxprice').val(), 10);

        // update visible input and slider using last known values
        jQuery('#price_from').val(currencySymbol + addCommas(value));
        jQuery('#price_to').val(currencySymbol + addCommas(value1));
        jQuery('#price_left_hidden').val(value.toFixed(0));
        jQuery('#price_right_hidden').val(value1.toFixed(0));
        price_slider_render(value, value1, false);
        return true;
    }

    let value = raw.replace(currencySymbol, '').replace(/,/g, '').replace(/[^\d\.]/g, '');
    let value1 = jQuery('#price_right_hidden').val().replace(currencySymbol, '').replace(/,/g, '').replace(/[^\d\.]/g, '');

    value = parseInt(value, 10);
    value1 = parseInt(value1, 10);

    if (isNaN(value)) {
        alert(store_lang == 'ja' ? "数値を入力してください。" : "Please enter value in number");
        jQuery('#price_from').val(currencySymbol + addCommas($('#diamondMinprice').val()));
        return false;
    }
    if (value < parseInt($('#diamondMinprice').val(), 10)) {
        alert(store_lang == 'ja' ? '価格帯が正しくない！' : 'Incorrect price range!');
        jQuery('#price_from').val(currencySymbol + addCommas($('#diamondMinprice').val()));
        return false;
    }
    if (value > value1) {
        alert(store_lang == 'ja' ? '価格帯が正しくない！' : 'Incorrect price range!');
        price_slider_render(parseInt($('#diamondMinprice').val(), 10), value1, false);
        return false;
    }

    jQuery('#price_left_hidden').val(value.toFixed(0));
    jQuery('#price_right_hidden').val(value1.toFixed(0));
    price_slider_render(value, value1, false);
}

/*** Diamond Price Filter End ***/

/*** Diamond Ratio Filter Start ***/
var ratio = [];

for (i = 0.2; i < 2.01; i = i + 0.01) {
	var dec = i.toFixed(2);
	ratio.push(dec);
}

var min_ratio_filter = 0.20;
var max_ratio_filter = 2.00;

if(store_lang == 'ja'){
  var ratioFilterUnit = '深さ';
}else{
  var ratioFilterUnit = 'Ratio';
} 

function ratio_slider_render(start, end, option) {
 
	var start2 = getClosestNum(start, ratio);
	var end2 = getClosestNum(end, ratio);
	var start1 = get_index(start2, ratio);
	var start11 = get_index(start, ratio);
	var end11 = get_index(end, ratio);
	var end1 = get_index(end2, ratio);

     //session Ratio filter selected
     var isSelected = false;      
     if(parseFloat(start) != parseFloat(min_ratio_filter) || parseFloat(end) != parseFloat(max_ratio_filter)){
       isSelected = true;
     }

     var ratioTitle = ratioFilterUnit+': '+start+' % - '+end+' %';
     setSelectedFilter(ratioTitle,"ratio_slider_render('"+min_ratio_filter+"', '"+max_ratio_filter+"','true')",isSelected,'ratio');
     //end
  
	jQuery("#ratio-slider").slider({
		range: true,
		min: 0,
		max: ratio.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#ratio_from").val(ratio[parseFloat(ui.values[0])] + '%');
			$('#ratio_left_hidden').val(ratio[parseFloat(ui.values[0])]);
			$('#ratio_to').val(ratio[parseFloat(ui.values[1])] + '%');
			$('#ratio_right_hidden').val(ratio[parseFloat(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}	

			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#ratio_from").val(ratio[parseFloat(ui.values[0])] + '%');
    			$('#ratio_left_hidden').val(ratio[parseFloat(ui.values[0])]);
    			$('#ratio_to').val(ratio[parseFloat(ui.values[1])] + '%');
    			$('#ratio_right_hidden').val(ratio[parseFloat(ui.values[1])]);

                 //applied filter start
                 var isSelected = false;               
                 if(ratio[parseFloat(ui.values[0])] != parseFloat(min_ratio_filter) || ratio[parseFloat(ui.values[1])] != parseFloat(max_ratio_filter)){
                       isSelected = true;
                 }
                var ratioTitle = ratioFilterUnit+': '+ratio[parseFloat(ui.values[0])] + ' %'+' - '+ratio[parseFloat(ui.values[1])] + ' %';
                setSelectedFilter(ratioTitle,"ratio_slider_render('"+min_ratio_filter+"', '"+max_ratio_filter+"','true')",isSelected,'ratio');
    			
            }
                //end
            
              // var reportFlag = jQuery('#tps_search_by_report_no').val();                
              // if(reportFlag == ''){
                graphqlDataCall();
              // }
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#ratio_from").val(Start_limit.toFixed(2) + '%');
	$("#ratio_to").val(End_limit.toFixed(2) + '%');
	$('#ratio_left_hidden').val(start);
	$('#ratio_right_hidden').val(end);
}

function replace_ratio_from() {

	var min_ratio_value = 0.20;

	if (jQuery('#ratio_from').val() == '') {
		var value = parseFloat(jQuery('#ratio_left_hidden').val());
		jQuery('#ratio_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var ratio_value = parseFloat(jQuery('#ratio_from').val());
		var hidden_ratio_value = $('#ratio_left_hidden').val();
	}
	
	var value = ratio_value;
	
	var ratio_value1_comma = value;
	value = ratio_value1_comma;

	var value1 = parseFloat($('#ratio_to').val());
	
	if (isNaN(value) != false) {
		var value = 0.20;
		if(store_lang == 'ja'){
          alert('数値を入力してください。');
        }else{
          alert('Please enter value in number');
        }	
		jQuery('#ratio_from').val(value + '%');
	} else if (value > value1) {
		if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect ratio range!');
        }
		var value = parseFloat(jQuery('#ratio_left_hidden').val());
		jQuery('#ratio_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (ratio_value < min_ratio_value) {
		if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect ratio range!');
        }
		$('#ratio_from').val(min_ratio_value + "%");
		ratio_slider_render(min_ratio_value, value1, true);
		return false;
	}

	$('#ratio_left_hidden').val(value);
	$('#ratio_right_hidden').val(value1);

	ratio_slider_render(value, value1, true);
}

function replace_ratio_to() {

	var max_ratio_value = 2;

	if (jQuery('#ratio_to').val() == '') {
		var value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var ratio_value = parseFloat(jQuery('#ratio_to').val());
		var hidden_ratio_value = $('#ratio_right_hidden').val();
	}	
	value = ratio_value;
	var ratio_value1_comma = value;
	value = ratio_value1_comma;

	var value1 = parseFloat($('#ratio_from').val());

	if (isNaN(value) != false) {
		var value = 2.00;
        if(store_lang == 'ja'){
          alert('数値を入力してください。');
        }else{
          alert('Please enter value in number');
        }		
		jQuery('#ratio_to').val(value + '%');
	} else if (value1 > value) {
        if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect ratio range!');
        }
		
		var value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > max_ratio_value) {
		if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect ratio range!');
        }
      
		$('#ratio_to').val(max_ratio_value + "%");
		ratio_slider_render(value1, max_ratio_value, true);
		return false;
	}

	$('#ratio_right_hidden').val(value);
	$('#ratio_left_hidden').val(value1);

	ratio_slider_render(value1, value, true);
}
/*** Diamond Ratio Filter End ***/

/*** Diamond Depth Filter Start ***/
var min_depth_filter = (typeof depth_min_range !== 'undefined') ? depth_min_range : 50.00;
var max_depth_filter = (typeof depth_max_range !== 'undefined') ? depth_max_range : 70.00;
var depth = [];

for (i = min_depth_filter; i < max_depth_filter + 0.001; i = i + 0.10) {
	var dec = i.toFixed(2);
	depth.push(dec);
}

if(store_lang == 'ja'){
  var depthFilterUnit = '深さ';
}else{
  var depthFilterUnit = 'Depth';
} 

function depth_slider_render(start, end, option) {
 
	var start2 = getClosestNum(start, depth);
	var end2 = getClosestNum(end, depth);
	var start1 = get_index(start2, depth);
	var start11 = get_index(start, depth);
	var end11 = get_index(end, depth);
	var end1 = get_index(end2, depth);

     //session depth filter selected
     var isSelected = false;      
     if(parseInt(start) != parseInt(min_depth_filter) || parseInt(end) != parseInt(max_depth_filter)){
       isSelected = true;
     }

     var depthTitle = depthFilterUnit+': '+start+' % - '+end+' %';
     setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth_filter+"', '"+max_depth_filter+"','true')",isSelected,'depth');
     //end
  
	jQuery("#depth-slider").slider({
		range: true,
		min: 0,
		max: depth.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}	

			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
    			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
    			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
    			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);

                 //applied filter start
                 var isSelected = false;               
                 if(depth[parseInt(ui.values[0])] != parseInt(min_depth_filter) || depth[parseInt(ui.values[1])] != parseInt(max_depth_filter)){
                       isSelected = true;
                 }
                var depthTitle = depthFilterUnit+': '+depth[parseInt(ui.values[0])] + ' %'+' - '+depth[parseInt(ui.values[1])] + ' %';
                setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth_filter+"', '"+max_depth_filter+"','true')",isSelected,'depth');
    			
            }
                //end
            
              // var reportFlag = jQuery('#tps_search_by_report_no').val();                
              // if(reportFlag == ''){
                graphqlDataCall();
              // }
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#depth_from").val(Start_limit.toFixed(2) + '%');
	$("#depth_to").val(End_limit.toFixed(2) + '%');
	$('#depth_left_hidden').val(start);
	$('#depth_right_hidden').val(end);
}

function replace_depth_from() {

	var min_depth_value = min_depth_filter;

	if (jQuery('#depth_from').val() == '') {
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_from').val());
		var hidden_depth_value = $('#depth_left_hidden').val();
	}
	
	var value = depth_value;
	
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_to').val());
	
	if (isNaN(value) != false) {
		var value = min_depth_filter;
		if(store_lang == 'ja'){
          alert('数値を入力してください。');
        }else{
          alert('Please enter value in number');
        }	
		jQuery('#depth_from').val(value + '%');
	} else if (value > value1) {
		if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect depth range!');
        }
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (depth_value < min_depth_value) {
		if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect depth range!');
        }
		$('#depth_from').val(min_depth_value + "%");
		depth_slider_render(min_depth_value, value1, true);
		return false;
	}

	$('#depth_left_hidden').val(value);
	$('#depth_right_hidden').val(value1);

	depth_slider_render(value, value1, true);
}

function replace_depth_to() {

	var max_depth_value = max_depth_filter;

	if (jQuery('#depth_to').val() == '') {
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_to').val());
		var hidden_depth_value = $('#depth_right_hidden').val();
	}	
	value = depth_value;
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_from').val());

	if (isNaN(value) != false) {
		var value = max_depth_filter;
        if(store_lang == 'ja'){
          alert('数値を入力してください。');
        }else{
          alert('Please enter value in number');
        }		
		jQuery('#depth_to').val(value + '%');
	} else if (value1 > value) {
        if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect depth range!');
        }
		
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > max_depth_value) {
		if(store_lang == 'ja'){
          alert('デプスレンジが正しくない！');
        }else{
          alert('Incorrect depth range!');
        }
      
		$('#depth_to').val(max_depth_value + "%");
		depth_slider_render(value1, max_depth_value, true);
		return false;
	}

	$('#depth_right_hidden').val(value);
	$('#depth_left_hidden').val(value1);

	depth_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/*** Diamond Table Filter Start ***/
var min_table_filter = (typeof table_min_range !== 'undefined') ? table_min_range : 50.00;
var max_table_filter = (typeof table_max_range !== 'undefined') ? table_max_range : 70.00;

var table = [];

for (i = min_table_filter; i < max_table_filter + 0.001; i = i + 0.10) {
	var dec = i.toFixed(2);
	table.push(dec);
}


if(store_lang == 'ja'){
  var tableFilterUnit = 'テーブル';
}else{
  var tableFilterUnit = 'Table';
} 

function table_slider_render(start, end, option) {
	var start2 = getClosestNum(start, table);
	var end2 = getClosestNum(end, table);
	var start1 = get_index(start2, table);
	var start11 = get_index(start, table);
	var end11 = get_index(end, table);
	var end1 = get_index(end2, table);

    //session depth filter selected
     var isSelected = false;
     if(start != parseInt(min_table_filter) || end != parseInt(max_table_filter)){
       isSelected = true;
     }

     var tableTitle = tableFilterUnit+': '+start+' % - '+end+' %';
     setSelectedFilter(tableTitle,"table_slider_render('"+parseInt(min_table_filter)+"', '"+parseInt(max_table_filter)+"','true')",isSelected,'table');
     //end
  
	jQuery("#table-slider").slider({
		range: true,
		min: 0,
		max: table.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#table_from").val(table[parseInt(ui.values[0])] + '%');
			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			
			if (option) {
				if (option == true) {
					jQuery('#page_no').val(1);
					jQuery('#pagination').val('');					

                    $("#table_from").val(table[parseInt(ui.values[0])] + '%');
        			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
        			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
        			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
                 
                    //applied filter start
                     var isSelected = false;
                     if(table[parseInt(ui.values[0])] != min_table_filter || table[parseInt(ui.values[1])] != max_table_filter){
                           isSelected = true;
                     }
                    var tableTitle = tableFilterUnit+': '+table[parseInt(ui.values[0])] + ' %'+' - '+table[parseInt(ui.values[1])] + ' %';
                    setSelectedFilter(tableTitle,"table_slider_render('"+min_table_filter+"', '"+max_table_filter+"','true')",isSelected,'table');

                    // var reportFlag = jQuery('#tps_search_by_report_no').val();                
                    // if(reportFlag == ''){
                      graphqlDataCall();
                    // }
				}


			}
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#table_from").val(Start_limit.toFixed(2) + '%');
	$("#table_to").val(End_limit.toFixed(2) + '%');

	$('#table_left_hidden').val(start);
	$('#table_right_hidden').val(end);
}

function replace_table_from() {

	var min_table_value = min_table_filter;

	if (jQuery('#table_from').val() == '') {
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_from').val());
		var hidden_table_value = $('#table_left_hidden').val();
	}
	
	var value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_to').val());
	
	if (isNaN(value) != false) {
		var value = min_table_filter;
        if(store_lang == 'ja'){
          alert('数値を入力してください。');
        }else{
          alert('Please enter value in number');
        }
		
		jQuery('#table_from').val(value + '%');
	} else if (value > value1) {
        if(store_lang == 'ja'){
    		alert('テーブルの範囲が正しくない！');
        }else{
            alert('Incorrect table range!');
        }
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (table_value < min_table_value) {
		if(store_lang == 'ja'){
    		alert('テーブルの範囲が正しくない！');
        }else{
            alert('Incorrect table range!');
        }
		$('#table_from').val(min_table_value + "%");
		table_slider_render(min_table_value, value1, true);
		return false;
	}

	$('#table_left_hidden').val(value);
	$('#table_right_hidden').val(value1);

	table_slider_render(value, value1, true);
}

function replace_table_to() {

	var max_table_value = max_table_filter;

	if (jQuery('#table_to').val() == '') {
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_to').val());
		var hidden_table_value = $('#table_right_hidden').val();
	}

	value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_from').val());
	
	if (isNaN(value) != false) {
		var value = max_table_filter;
		if(store_lang == 'ja'){
          alert('数値を入力してください。');
        }else{
          alert('Please enter value in number');
        }
		jQuery('#table_to').val(value + '%');
	} else if (value1 > value) {
		if(store_lang == 'ja'){
    		alert('テーブルの範囲が正しくない！');
        }else{
            alert('Incorrect table range!');
        }
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > max_table_value) {
		$('#table_to').val(max_table_value + "%");
		table_slider_render(value1, max_table_value, true);
		return false;
	}

	$('#table_right_hidden').val(value);
	$('#table_left_hidden').val(value1);

	table_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/************************** Start - Diamond Color Filter **************************/
  var min_color = jQuery( "#color-min-value" ).val();
  var max_color = jQuery( "#color-max-value" ).val();

  if(store_lang == 'ja'){
    var colorFilterUnit = 'カラー';
  }else{
    var colorFilterUnit = 'Color';
  }  

  function color_slider_render(start,end,option){
    
    //session color filter selected
    var isSelected = false;
    if(start != 0 || end != 7){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_color,max_color,'color');

    if(selected_values[0] == selected_values[1]){
      var colorTitle = colorFilterUnit+': '+selected_values[1];
    }else{
        var colorTitle = colorFilterUnit+': '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(colorTitle,"color_slider_render('0', '7','false')",isSelected,'color');
      //end

      jQuery( "#color_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 7,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#color-min-value" ).val(ui.values[0]);
            jQuery( "#color-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#color-min-value" ).val(ui.values[0]);
           jQuery( "#color-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 7){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'color');
            
            if(selected_values[0] == selected_values[1]){
              var colorTitle = colorFilterUnit+': '+selected_values[1];    
            }else{
              var colorTitle = colorFilterUnit+': '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(colorTitle,"color_slider_render('0', '7','false')",isSelected,'color');
           //end
          
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond Color Filter **************************/

/************************** Start - Diamond clarity Filter **************************/
  var min_clarity = jQuery( "#clarity-min-value" ).val();
  var max_clarity = jQuery( "#clarity-max-value" ).val();

  if(store_lang == 'ja'){
    var clarityFilterUnit = 'クラリティ';
  }else{
    var clarityFilterUnit = 'Clarity';
  }  

  function clarity_slider_render(start,end,option){

    //session clarity filter selected
    var isSelected = false;
    if(start != 0 || end != 8){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_clarity,max_clarity,'clarity');

    if(selected_values[0] == selected_values[1]){
      var clarityTitle = clarityFilterUnit+': '+selected_values[1];
    }else{
        var clarityTitle = clarityFilterUnit+': '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(clarityTitle,"clarity_slider_render('0', '8','false')",isSelected,'clarity');
      //end

      jQuery( "#clarity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 8,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#clarity-min-value" ).val(ui.values[0]);
            jQuery( "#clarity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#clarity-min-value" ).val(ui.values[0]);
           jQuery( "#clarity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 8){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'clarity');
            
            if(selected_values[0] == selected_values[1]){
              var clarityTitle = clarityFilterUnit+': '+selected_values[1];    
            }else{
              var clarityTitle = clarityFilterUnit+': '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(clarityTitle,"clarity_slider_render('0', '8','false')",isSelected,'clarity');
           //end
          
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond clarity Filter **************************/

/************************** Start - Diamond Cut Filter **************************/
var min_cut = jQuery( "#cut-min-value" ).val();
var max_cut = jQuery( "#cut-max-value" ).val();

var cutMax = (typeof cut_max_range !== 'undefined') ? cut_max_range : 4;

if(store_lang == 'ja'){
  var cutFilterUnit = 'カット';
}else{
  var cutFilterUnit = 'Cut';
}  

function cut_slider_render(start,end,option){  
  //session cut filter selected
  var isSelected = false;
  if(start != 0 || end != cutMax){
     isSelected = true;
  }
  var threex = localStorage.getItem("diamond_3x_filter");
  if(start==1 && end==2 && threex == "true"){
    jQuery('.tps_3x_button').addClass('active');
    jQuery('.threex-switch-label').addClass('active');
    $(".tps_3x_button").prop('checked', true); 
  }else{
    localStorage.removeItem("diamond_3x_filter");
    jQuery('.tps_3x_button').removeClass('active');
    jQuery('.threex-switch-label').removeClass('active');
    $(".tps_3x_button").prop('checked', false); 
  }
  var selected_values = getFilterValues(min_cut,max_cut,'cut');
  
  if(selected_values[0] == selected_values[1]){
    var cutTitle = cutFilterUnit+': '+selected_values[1];
  }else{
    var cutTitle = cutFilterUnit+': '+selected_values[0]+' - '+selected_values[1];
  }
      
  
  setSelectedFilter(cutTitle,"cut_slider_render('0', '" + cutMax + "', 'false')",isSelected,'cut');
  //end
  
  jQuery( "#cut_range" ).slider({ 
      range: true,
      values: [start, end],
       min: 0,
       max: cutMax,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
           if(ui.values[0]==1 && ui.values[1]==2 && threex == "true"){
              jQuery('.tps_3x_button').addClass('active');
              jQuery('.threex-switch-label').addClass('active');
              $(".tps_3x_button").prop('checked', true); 
           }else{
              localStorage.removeItem("diamond_3x_filter");
              jQuery('.tps_3x_button').removeClass('active');
              jQuery('.threex-switch-label').removeClass('active');
              $(".tps_3x_button").prop('checked', false); 
           }   
             
          jQuery( "#cut-min-value" ).val(ui.values[0]);
          jQuery( "#cut-max-value" ).val(ui.values[1]);
           
      },
      change: function( event, ui ) {  
         emptyResultDiv();
        
         jQuery( "#cut-min-value" ).val(ui.values[0]);
         jQuery( "#cut-max-value" ).val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != cutMax){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'cut');
          
          if(selected_values[0] == selected_values[1]){
            var cutTitle = cutFilterUnit+': '+selected_values[1];    
          }else{
            var cutTitle = cutFilterUnit+': '+selected_values[0]+' - '+selected_values[1];    
          }
          
          
          setSelectedFilter(cutTitle,"cut_slider_render('0', '" + cutMax + "','false')",isSelected,'cut');
         //end
        
        jQuery('#page_no').val(1);
	    jQuery('#pagination').val('');
        graphqlDataCall();
        return false;
      }
   });
}
/************************** End - Diamond Cut Filter **************************/

/************************** Start - Diamond Polish Filter **************************/
  var min_polish = jQuery( "#polish-min-value" ).val();
  var max_polish = jQuery( "#polish-max-value" ).val();

  var polishMax = (typeof polish_max_range !== 'undefined') ? polish_max_range : 3;

  if(store_lang == 'ja'){
    var polishFilterUnit = 'ポリッシュ';
  }else{
    var polishFilterUnit = 'Polish';
  }  

  function polish_slider_render(start,end,option){

    //session Polish filter selected
    var isSelected = false;
    if(start != 0 || end != polishMax){
       isSelected = true;
    }
    var threex = localStorage.getItem("diamond_3x_filter");
    if(start==1 && end==2 && threex == "true"){
      jQuery('.tps_3x_button').addClass('active');
      jQuery('.threex-switch-label').addClass('active');
      $(".tps_3x_button").prop('checked', true); 
    }else{
      localStorage.removeItem("diamond_3x_filter");
      jQuery('.tps_3x_button').removeClass('active');
      jQuery('.threex-switch-label').removeClass('active');
      $(".tps_3x_button").prop('checked', false); 
    }
    
    var selected_values = getFilterValues(min_polish,max_polish,'polish');

    if(selected_values[0] == selected_values[1]){
      var polishTitle = polishFilterUnit+': '+selected_values[1];
    }else{
        var polishTitle = polishFilterUnit+': '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(polishTitle,"polish_slider_render('0', '"+polishMax+"','false')",isSelected,'polish');
      //end

      jQuery( "#polish_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: polishMax,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
            if(ui.values[0]==1 && ui.values[1]==2 && threex == "true"){
                  jQuery('.tps_3x_button').addClass('active');
                  jQuery('.threex-switch-label').addClass('active');
                  $(".tps_3x_button").prop('checked', true); 
            }else{
                  localStorage.removeItem("diamond_3x_filter");
                  jQuery('.tps_3x_button').removeClass('active');
                  jQuery('.threex-switch-label').removeClass('active');
                  $(".tps_3x_button").prop('checked', false); 
            }      
            jQuery( "#polish-min-value" ).val(ui.values[0]);
            jQuery( "#polish-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#polish-min-value" ).val(ui.values[0]);
           jQuery( "#polish-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != polishMax){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'polish');
            
            if(selected_values[0] == selected_values[1]){
              var polishTitle = polishFilterUnit+': '+selected_values[1];    
            }else{
              var polishTitle = polishFilterUnit+': '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
            setSelectedFilter(polishTitle,"polish_slider_render('0', '"+polishMax+"','false')",isSelected,'polish');
           //end
          
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond Polish Filter **************************/

/************************** Start - Diamond Intensity Filter **************************/
  var min_intensity = jQuery( "#intensity-min-value" ).val();
  var max_intensity = jQuery( "#intensity-max-value" ).val();

  if(store_lang == 'ja'){
    var intensityFilterUnit = '色の強さ';
  }else{
    var intensityFilterUnit = 'Intensity';
  }  

  function intensity_slider_render(start,end,option){

    //session intensity filter selected
    var isSelected = false;
    if(start != 0 || end != 6){
       isSelected = true;
    }
   
    
    var selected_values = getFilterValues(min_intensity,max_intensity,'intensity');

    if(selected_values[0] == selected_values[1]){
      var intensityTitle = intensityFilterUnit+': '+selected_values[1];
    }else{
        var intensityTitle = intensityFilterUnit+': '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(intensityTitle,"intensity_slider_render('0', '6','false')",isSelected,'intensity');
      //end

      jQuery( "#intensity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 6,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;            }
                 
            jQuery( "#intensity-min-value" ).val(ui.values[0]);
            jQuery( "#intensity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#intensity-min-value" ).val(ui.values[0]);
           jQuery( "#intensity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 6){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'intensity');
            
            if(selected_values[0] == selected_values[1]){
              var intensityTitle = intensityFilterUnit+': '+selected_values[1];    
            }else{
              var intensityTitle = intensityFilterUnit+': '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
            setSelectedFilter(intensityTitle,"intensity_slider_render('0', '6','false')",isSelected,'intensity');
           //end
          
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond Intensity Filter **************************/

/************************** Start - Diamond Symmetry Filter **************************/
  var min_symmetry = jQuery( "#symmetry-min-value" ).val();
  var max_symmetry = jQuery( "#symmetry-max-value" ).val();

  var symmetryMax = (typeof symmetry_max_range !== 'undefined') ? symmetry_max_range : 3;

  if(store_lang == 'ja'){
    var symmetryFilterUnit = 'シンメトリー';
  }else{
    var symmetryFilterUnit = 'Symmetry';
  }  

  function symmetry_slider_render(start,end,option){
    //session Symmetry filter selected
    var isSelected = false;
    if(start != 0 || end != symmetryMax){
       isSelected = true;
    }
    var threex = localStorage.getItem("diamond_3x_filter");
    if(start==1 && end==2 && threex == "true"){
      jQuery('.tps_3x_button').addClass('active');
      jQuery('.threex-switch-label').addClass('active');
      $(".tps_3x_button").prop('checked', true); 
    }else{
      localStorage.removeItem("diamond_3x_filter");
      jQuery('.tps_3x_button').removeClass('active');
      jQuery('.threex-switch-label').removeClass('active');
      $(".tps_3x_button").prop('checked', false); 
    }
    var selected_values = getFilterValues(min_symmetry,max_symmetry,'symmetry');

    if(selected_values[0] == selected_values[1]){
      var symmetryTitle = symmetryFilterUnit+': '+selected_values[1];
    }else{
        var symmetryTitle = symmetryFilterUnit+': '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', '"+symmetryMax+"','false')",isSelected,'symmetry');
      //end

      jQuery( "#symmetry_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: symmetryMax,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }

           if(ui.values[0]==1 && ui.values[1]==2 && threex == "true"){
                jQuery('.tps_3x_button').addClass('active');
                jQuery('.threex-switch-label').addClass('active');
                $(".tps_3x_button").prop('checked', true); 
            }else{
                localStorage.removeItem("diamond_3x_filter");
                jQuery('.tps_3x_button').removeClass('active');
                jQuery('.threex-switch-label').removeClass('active');
                $(".tps_3x_button").prop('checked', false); 
            }   
           
            jQuery( "#symmetry-min-value" ).val(ui.values[0]);
            jQuery( "#symmetry-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#symmetry-min-value" ).val(ui.values[0]);
           jQuery( "#symmetry-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != symmetryMax){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'symmetry');
            
            if(selected_values[0] == selected_values[1]){
              var symmetryTitle = symmetryFilterUnit+': '+selected_values[1];    
            }else{
              var symmetryTitle = symmetryFilterUnit+': '+selected_values[0]+' - '+selected_values[1];    
            }
                        
            setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', '"+symmetryMax+"','false')",isSelected,'symmetry');
           //end
          
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall();
          return false;
        }
     });
  }
/************************** End - Diamond Symmetry Filter **************************/

function getFilterValues(min_value,max_value,filter) { 
  var filterArray = '';
  if(filter == 'cut'){
    if(store_lang == 'ja'){
        filterArray = ja_cut_array;
    } else {
      filterArray = cut_array;  
    }
  // }else if(filter == 'polish'){
  //   filterArray = polish_array;  
  }else if(filter == 'polish'){
    if(store_lang == 'ja'){
        filterArray = ja_polish_array;
    } else {
        filterArray = polish_array;
    }
  }else if(filter == 'intensity'){
    if(store_lang == 'ja'){
        filterArray = ja_intensity_array;
    } else {
        filterArray = intensity_array;
    }
  }else if(filter == 'symmetry'){
    if(store_lang == 'ja'){
        filterArray = ja_symmetry_array;
    } else {
        filterArray = symmetry_array;
    }
  // }else if(filter == 'symmetry'){
  //   filterArray = symmetry_array;  
  }else if(filter == 'fluorescence'){
    if(store_lang == 'ja'){
        filterArray = ja_fluor;
    } else {
        filterArray = fluorescence_array;
    }
  }else if(filter == 'clarity'){
    filterArray = clarity_array;  
  }else if(filter == 'color'){
    filterArray = color_array;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array;  
  }

  var i=0;
  var selected_values = [];
  $.each(filterArray, function(key,value){    
      if(i == min_value){
        // if(store_lang == 'ja'){
        //   selected_values.push(value);
        // }else{
          selected_values.push(key);
        //}        
      }
      if(i == max_value-1){
         // if(store_lang == 'ja'){
         //  selected_values.push(value);
         // }else{
           selected_values.push(key);
         //}
      }
    i++;     
  });  
  return selected_values;
}

/***Diamond sorting Filter Start ***/
function sorting_data(sorting, className) {
    emptyResultDiv();
  
	var sortorder = '';
	var clas = className;

	jQuery('.datagrid-sort').each(function() {
		if (jQuery(this).hasClass('fa-angle-up')) {
			jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');
		}
	});

	if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {
		sortorder = 'desc';
		jQuery(clas).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
	} else {
		sortorder = 'asc';
		jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
	}

    //grid view
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value'); 
     
    jQuery('.sortvaluename').text(sort_text);  
  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);


	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();
 
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
	graphqlDataCall();
}
/*** Diamond sorting Filter End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** Mobile Gallery Functinality Start ***/ 
$(document).on("click", ".tps_dots", function() {
  var data_thumb = jQuery(this).attr("data-thumb");  
  jQuery(".tps_dots").removeClass("active"); 
  jQuery(this).addClass("active");
  
  jQuery(".tps_mobile_gallery_image").hide(); 
  jQuery(".tps_image_"+data_thumb).show(); 
});
/*** End ***/

/*** Diamond Add To Cart Diamond Listing Page ***/
jQuery(document).on('click','.tps_addtocart',function(e){   
  var diamond_id = jQuery(this).attr("data-id");
  var diamond_image = jQuery(this).attr("data-image");  
  var diamond_type = jQuery('#diamond_type').val(); 
  $(this).addClass("tps_add_to_cart");

  var lang = store_lang.toUpperCase();
  $(".tps_add_to_cart_loader_"+diamond_id).addClass("active");
  jQuery(".tps_add_to_cart_loader_"+diamond_id).addClass("tps_loader_show");
  

  //query parameters for graphql diamond add to cart call
    var postdata = JSON.stringify({ query:`{
                    ${diamondAddToCart}(diamondId: "` +
                diamond_id +
                `",diamondType:"` +
                diamond_type +
                `",langCode:"`+lang+`")
                    {      
                      status
                       code
                       message                       
                       productId
                       variantId                       
                    }
                    }
                    `});     

       jQuery.ajax({
        url:api,
        contentType: "application/json",
        type:'POST',
        data: postdata,
        success: function(response) {  
          var variant_id = response.data.diamondAddToCart.variantId;
                  
          setTimeout(function(){ 
            
              var productSku = [];
              
              jQuery.getJSON('/cart.js', function(cart) {
               if(cart.items != '' ){                     
                 $(cart.items).each(function(index, value) { 
                     var str = "-";   
                     var sku = value.sku;

                     if(sku.indexOf(str) != -1){                  
                       sku = sku.split('-');
                       sku = sku[1];                       
                     }else{
                       var sku = value.sku;                   
                     }
                     productSku.push(sku);                                    
                 });
                                         
                 setTimeout(function(){ 
                  if($.inArray(diamond_id, productSku)!=(-1)){ 
                    alert("Product already in cart.");
                    jQuery(".tps_add_to_cart_loader_"+diamond_id).removeClass("tps_loader_show");
                    jQuery(".tps_addtocart").removeClass("tps_add_to_cart");
                  }else{                        
                    looseDiamondAddToCart(variant_id);
                  }
                }, 50);                    
               }else{
                 looseDiamondAddToCart(variant_id);
               }              
              });                                  
            
          }, 5000); 
        },
        error: function (xhr, ajaxOptions, thrownError) {
           alert(xhr.status);
           alert(thrownError);           
            jQuery(".tps_add_to_cart_loader_"+diamond_id).removeClass('tps_loader_show');
         }
      }); 
  
});

function looseDiamondAddToCart(add_id){     
  jQuery.post('/cart/add.js', {
    quantity:1,
    id: add_id,
  });
 
  setTimeout(function(){
    if(store_lang == 'ja'){
      window.location.href = "/ja/cart";
    }else{
      window.location.href = "/cart";
    }    
  }, 1000);  
  
 jQuery(".tps_add_to_cart_loader").removeClass('tps_loader_show');
}
/*** End ***/